const ASSET_CODE_PATTERN = /^NJ-[A-Z0-9]{12}$/

export function isAssetCode(value: string): boolean {
  return ASSET_CODE_PATTERN.test(value)
}
